/**
 * Labstep
 *
 * @module components/FilterPost/Report/Date/Active/Post
 * @desc Active node component for date
 */

import type { FilterPostActiveLabelProps } from 'labstep-web/components/FilterPost/Active/Label/types';
import { FilterPostReportDate } from 'labstep-web/components/FilterPost/Report/Date';
import { useParamsContext } from 'labstep-web/contexts/params/hook';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import type React from 'react';
import { getPostFilterDate } from '../../Form';
import { COMPARISON_OPTIONS } from '../../Form/fields';

export enum PostFilterComparisonHumanReadable {
  lt = 'Before',
  gt = 'After',
  not_null = 'Has value',
}

export const FilterPostReportDateActivePost: React.FC<
  FilterPostActiveLabelProps
> = ({ node, onRemoveClick, index }) => {
  const DATE_FILTERS = [
    getPostFilterDate(
      'created_at',
      PostFilterComparison.not_null,
      'experiment.experimentWorkflow',
    ),
    getPostFilterDate(
      'started_at',
      PostFilterComparison.not_null,
      'experiment.experimentWorkflow',
    ),
    getPostFilterDate(
      'ended_at',
      PostFilterComparison.not_null,
      'experiment.experimentWorkflow',
    ),
    getPostFilterDate(
      'started_at',
      PostFilterComparison.not_null,
      'experiment',
    ),
    getPostFilterDate(
      'ended_at',
      PostFilterComparison.not_null,
      'experiment',
    ),
  ];
  const { addPostFilter } = useParamsContext();
  const filterActive = DATE_FILTERS.find((filter) =>
    filter.isNodeActive(node),
  );
  if (!filterActive) {
    return null;
  }

  const path = filterActive.getPath() || '';
  const attributes = filterActive.getAttributeValues(node);

  const label = filterActive.getHumanReadableString(node) || '';
  const field = Object.keys(attributes)[0];
  const { comparison } = Object.values(attributes)[0];
  const value =
    comparison === PostFilterComparison.not_null
      ? ''
      : Object.values(attributes)[0].value;

  const defaultValues = {
    comparison: COMPARISON_OPTIONS.find(
      (option) => option.value === comparison,
    ),
    value,
  };

  const postFilterSettings = {
    label,
    path,
    field,
  };

  return (
    <FilterPostReportDate
      label={label}
      path={postFilterSettings.path}
      field={postFilterSettings.field}
      addPostFilter={addPostFilter}
      defaultValues={defaultValues}
      viewComponent={({ toggleModal }) => (
        <RemoveLabel
          name={filterActive.getHumanReadableStringWithValue(node)}
          onNameClick={toggleModal}
          onRemoveClick={onRemoveClick}
        />
      )}
      replace={index}
    />
  );
};
